import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  dividerContainer: {
    paddingHorizontal: 16,
  },
  divider: (width, height, theme, color) => ({
    height,
    width,
    backgroundColor: color || theme.colors.dividerTwo,
  }),
});
